export default "__VITE_ASSET__BKUk4xN9__"